<template>
  <v-row no-gutters class="pt-2">
      <v-col v-for="(item, i) in report" :key="i-9999" cols="6" sm="6" md="3" lg="2" class="pa-1">
      <v-card :color="item.color" dark>
        <div class="d-flex pointer" @click="changeRouter(item.value)">
          <v-avatar class="my-2" size="90" tile>
            <v-icon x-large>{{item.src}}</v-icon>
          </v-avatar>
          <v-card-title class="subtitle-1 px-0 pt-3" v-html="item.title"></v-card-title>
        </div>
        <div class="help" @click="helpDialog">
          <v-icon>help</v-icon>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
  export default {
    data () {
      return {
          report: [
      {
          title: "Customer",
          value: "/customer",
          color: "#211C5B",
          src: "people",
        },
        // {
        //   title: "Township/City",
        //   value: "/townshipandcity",
        //   color: "#211C5B",
        //   src: "location_city",
        // },
        {
          title: "Bank",
          value: "/bank",
          color: "#211C5B",
          src: "account_balance",
        },
        {
          title: "Branch",
          value: "/branch",
          color: "#211C5B",
          src: "store",
        },
        {
          title: "Online Shopping",
          value: "/onlineshopping",
          color: "#211C5B",
          src: "perm_contact_calendar",
        },
        {
          title: "UserAccount",
          value: "/account",
          color: "#211C5B",
          src: "person_add",
        },
        {
          title: "Company Profile",
          value: "/companyProfile",
          color: "#211C5B",
          src: "recent_actors",
        },
    ],
      }
    },
    mounted:function(){ },
    props: {},
    methods:{
      changeRouter:function(path){
          this.$router
          .push({
            path: path
          })
          .catch(() => {});
      }
    },
    watch:{
    }
  }
</script>
<style scoped>

</style>